module.exports = __webpack_public_path__ + "static/img/popup-swiper3.3ddda85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup-swiper3.png
// module id = ChtB
// module chunks = 0